/**
 * ProblemSection - 문제점 공감 섹션
 *
 * 학원이 겪는 채점 관련 문제점 3가지를 카드 형식으로 제시
 * - 채점 시간 문제
 * - 답 노출 문제
 * - 인건비 문제
 */

import React from 'react';
import { Typography, Row, Col, Card } from 'antd';
import {
  ClockCircleOutlined,
  EyeOutlined,
  DollarOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

// 문제점 데이터
const problems = [
  {
    icon: <ClockCircleOutlined style={{ fontSize: '48px', color: '#ff7875' }} />,
    title: '채점에 시간이 너무 많이 들어요',
    description:
      '선생님의 소중한 시간이 단순 채점 작업에 묶여있습니다. 수업 준비와 학생 관리에 집중하고 싶은데...',
  },
  {
    icon: <EyeOutlined style={{ fontSize: '48px', color: '#ffc53d' }} />,
    title: '학생에게 답을 주면 답만 외워요',
    description:
      '학생에게 답안지를 주고 채점하면 답을 미리 알게 됩니다. 진짜 실력 향상이 아닌 답 암기만 하게 되죠.',
  },
  {
    icon: <DollarOutlined style={{ fontSize: '48px', color: '#73d13d' }} />,
    title: '채점 알바 고용, 비용 부담돼요',
    description:
      '채점 전담 인력을 고용하자니 인건비 부담이 크고, 관리도 쉽지 않습니다.',
  },
];

export const ProblemSection: React.FC = () => {
  return (
    <section
      style={{
        background: '#f8f9fa',
        padding: '80px 24px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* 섹션 제목 */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Text
            style={{
              color: '#ff7875',
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            Problem
          </Text>
          <Title
            level={2}
            style={{
              marginTop: '8px',
              marginBottom: '16px',
              fontSize: 'clamp(24px, 4vw, 36px)',
            }}
          >
            이런 고민, 하고 계시죠?
          </Title>
        </div>

        {/* 문제점 카드들 */}
        <Row gutter={[24, 24]} justify="center">
          {problems.map((problem, index) => (
            <Col xs={24} sm={24} md={8} key={index}>
              <Card
                bordered={false}
                style={{
                  height: '100%',
                  borderRadius: '16px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  textAlign: 'center',
                }}
                bodyStyle={{ padding: '40px 24px' }}
              >
                {/* 아이콘 */}
                <div style={{ marginBottom: '24px' }}>{problem.icon}</div>

                {/* 제목 */}
                <Title
                  level={4}
                  style={{
                    marginBottom: '16px',
                    fontSize: '18px',
                    lineHeight: 1.4,
                  }}
                >
                  {problem.title}
                </Title>

                {/* 설명 */}
                <Text
                  type="secondary"
                  style={{
                    fontSize: '15px',
                    lineHeight: 1.7,
                  }}
                >
                  {problem.description}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};
